import { Typography } from "@mui/material";

const shopDetails = {
    banner: {
        title: "Mperito POS",
        subTitle: "Run your store. Right from your mobile.",
        button1Label: "Get Started",
        button2Label: "Request Demo",
        backgroundImage: "/assets/solutions/pos/mperito_pos_banner.png"
    },
    sectionHeading: {
        title: <span>
            Billing, Inventory & Retail Management Software!{' '}
            <Typography component="span" variant="inherit" color="primary">
                Solution Is Here
            </Typography>
        </span>,
        subTitle: "Manage billing, inventory, customers, expenses and business insights with Mperito POS. Use your mobile or desktop to manage your store"
    },
    features: [
        {
            label: 'ONBOARD',
            title: 'Get Your Store Ready to Go',
            description:
                'Start with a simple setup and bring your business onto Mperito POS',
            illustration: '/assets/images/solution/pos/mperito_pos_01_onboarding.jpg',
            list: [
                "Register your store or business",
                "Sign in easily using mobile OTP",
                "Select the business you want to manage when multiple businesses are registered",
                "Configure your business profile and essential settings",
            ]
        },
        {
            label: 'CATALOGUE',
            title: 'Build Your Product Catalogue',
            description:
                'Organize your products and services so they are ready for billing',
            illustration: '/assets/images/solution/pos/mperito_pos_02_catalogue.jpg',
            list: [
                "Define your own product categories",
                "Add product names, images, descriptions, prices, quantities and applicable taxes",
                "Make products easier to recognize with photos",
                "Configure barcodes or QR codes for quick product scanning",
            ]
        },
        {
            label: 'INVENTORY',
            title: 'Keep Track of Your Stock',
            description:
                'Know what is available, identify low-stock products and keep product details up to date',
            illustration: '/assets/images/solution/pos/mperito_pos_03_inventory.jpg',
            list: [
                "Order Insights",
                "Revenue Insights",
                "Trends on product Sales",
                "Valued Customers"
            ],
        },
        {
            label: 'CUSTOMERS',
            title: 'Keep Customer Information Organized',
            description:
                'Maintain customer details to make order management and customer service easier.',
            illustration: '/assets/images/solution/pos/mperito_pos_04_customers.jpg',
            list: [
                "View your customer list",
                "Access individual customer details",
                "Add new customers",
                "Update customer names and addresses",
            ],
        },
        {
            label: 'ORDERS',
            title: "Create Orders. Generate Bills. Serve Customers.",
            description:
                'Manage the order journey from adding products to generating an invoice and preparing an order for delivery.',
            illustration: '/assets/images/solution/pos/mperito_pos_05_orders.jpg',
            list: [
                "Add products to the cart and create orders",
                "Search orders by customer, mobile number, order ID, item or date",
                "View complete order details",
                "Generate and print GST or non-GST invoices according to business settings",
                "Share order and invoice PDFs through WhatsApp and other supported sharing options",
                "Print package slips for delivery management",
                "Record offline payment collection details for tracking"
            ],
        },
        {
            label: 'EXPENSES',
            title: "Keep Your Business Expenses in View",
            description:
                'Record everyday business expenses and review spending over time.',
            illustration: '/assets/images/solution/pos/mperito_pos_06_expenses.jpg',
            list: [
                "Define expense categories",
                "Enter and manage business expenses",
                "View monthly expense summaries",
            ],
        },
        {
            label: 'INSIGHTS',
            title: "Understand Your Business Better",
            description:
                'Turn business activity into useful information for everyday decisions.',
            illustration: '/assets/images/solution/pos/mperito_pos_07_insights.jpg',
            list: [
                "View key business metrics at a glance",
                "Analyse orders and sales trends",
                "Explore product sales patterns",
                "Review profit information when the necessary cost and expense data is available"
            ],
        },
        {
            label: 'CONFIGURE',
            title: "Make Mperito POS Work for Your Business",
            description:
                'Set up the details that define how your store operates.',
            illustration: '/assets/images/solution/pos/mperito_pos_08_store_settings.jpg',
            list: [
                "Configure your business name, logo and address",
                "Enable GST and configure your GSTIN, where applicable",
                "Add your website URL and FSSAI number, where applicable",
                "Configure supported printers and paper formats, including 80 mm and A4",
                "Choose your bill or invoice template",
                "Manage owner-only business settings"
            ],
        }
    ],
    
}

export default shopDetails;